(function () {
  let activeSheet = null;
  let overlay = null;

  function getOverlay() {
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = 'ohp-card__overlay';
      document.body.appendChild(overlay);
      overlay.addEventListener('click', closeSheet);
    }
    return overlay;
  }

  function openSheet(sheet) {
    if (activeSheet) closeSheet();
    activeSheet = sheet;
    sheet.removeAttribute('hidden');
    getOverlay().classList.add('is-open');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        sheet.classList.add('is-open');
      });
    });
    document.body.style.overflow = 'hidden';
  }

  function closeSheet() {
    if (!activeSheet) return;
    activeSheet.classList.remove('is-open');
    getOverlay().classList.remove('is-open');
    document.body.style.overflow = '';

    var sheet = activeSheet;
    activeSheet = null;

    sheet.querySelectorAll('.ohp-card__size-btn.is-selected').forEach(function (b) {
      b.classList.remove('is-selected');
    });
    var atcBtn = sheet.querySelector('.ohp-card__atc-btn');
    if (atcBtn) {
      atcBtn.disabled = true;
    }
    var variantInput = sheet.querySelector('.ohp-card__variant-input');
    if (variantInput) {
      variantInput.value = '';
    }

    setTimeout(function () {
      sheet.setAttribute('hidden', '');
    }, 320);
  }

  document.addEventListener('click', function (e) {
    var bagBtn = e.target.closest('.ohp-card__bag-btn');
    var quickBuyBtn = e.target.closest('.ohp-card__quick-buy-overlay');
    if (bagBtn || quickBuyBtn) {
      e.preventDefault();
      var card = (bagBtn || quickBuyBtn).closest('.ohp-card');
      if (!card) return;
      var sheet = card.querySelector('.ohp-card__quick-add');
      if (sheet) openSheet(sheet);
      return;
    }

    var closeBtn = e.target.closest('.ohp-card__quick-add-close');
    if (closeBtn) {
      e.preventDefault();
      closeSheet();
      return;
    }

    var sizeBtn = e.target.closest('.ohp-card__size-btn');
    if (sizeBtn && !sizeBtn.disabled) {
      e.preventDefault();
      var sizes = sizeBtn.closest('.ohp-card__sizes');
      if (sizes) {
        sizes.querySelectorAll('.ohp-card__size-btn').forEach(function (b) {
          b.classList.remove('is-selected');
        });
      }
      sizeBtn.classList.add('is-selected');

      var quickAdd = sizeBtn.closest('.ohp-card__quick-add');
      if (quickAdd) {
        var input = quickAdd.querySelector('.ohp-card__variant-input');
        var btn = quickAdd.querySelector('.ohp-card__atc-btn');
        if (input) input.value = sizeBtn.dataset.variantId;
        if (btn) btn.disabled = false;
      }
      return;
    }
  });

  document.addEventListener('submit', function (e) {
    if (!e.target.classList.contains('ohp-card__atc-form')) return;
    e.preventDefault();

    var form = e.target;
    var variantId = form.querySelector('.ohp-card__variant-input').value;
    if (!variantId) return;

    var btn = form.querySelector('.ohp-card__atc-btn');
    var origText = btn.textContent;
    btn.textContent = 'ADDING...';
    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] }),
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Add to cart failed');
        return r.json();
      })
      .then(function () {
        btn.textContent = 'ADDED!';
        setTimeout(function () {
          closeSheet();
          btn.textContent = origText;
          // Refresh cart count in header
          fetch('/cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              var counters = document.querySelectorAll('.cart-count-bubble span[aria-hidden]');
              counters.forEach(function (el) { el.textContent = cart.item_count; });
              var bubbles = document.querySelectorAll('.cart-count-bubble');
              bubbles.forEach(function (b) {
                if (cart.item_count > 0) b.removeAttribute('hidden');
              });
            });
        }, 800);
      })
      .catch(function () {
        btn.textContent = 'ERROR – TRY AGAIN';
        btn.disabled = false;
        setTimeout(function () {
          btn.textContent = origText;
        }, 2000);
      });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeSheet();
  });

  function hashSeed(value) {
    var seed = 0;
    var text = String(value);
    for (var i = 0; i < text.length; i++) {
      seed = ((seed << 5) - seed + text.charCodeAt(i)) | 0;
    }
    return Math.abs(seed);
  }

  function updateWishlistAriaLabel(el, count) {
    var prefix = el.dataset.wishlistPrefix || '';
    var suffix = el.dataset.wishlistSuffix || '';
    el.setAttribute('aria-label', prefix + ' ' + count + ' ' + suffix);
  }

  function wishlistSeed(el) {
    return hashSeed(
      (el.dataset.wishlistSeed || '') +
        el.dataset.wishlistCount +
        el.style.getPropertyValue('--wishlist-delay')
    );
  }

  function wishlistDelay(seed, step, min, max) {
    var span = max - min + 1;
    return min + ((seed * 7919 + step * 2654435761) >>> 0) % span;
  }

  function isWishlistInView(el) {
    var rect = el.getBoundingClientRect();
    return rect.top < window.innerHeight * 0.92 && rect.bottom > window.innerHeight * 0.08;
  }

  function markWishlistSettled(el) {
    el.classList.add('is-settled');
  }

  function flashWishlistTick(el) {
    el.classList.remove('is-ticking');
    void el.offsetWidth;
    el.classList.add('is-ticking');
    clearTimeout(el._wishlistTickTimer);
    el._wishlistTickTimer = setTimeout(function () {
      el.classList.remove('is-ticking');
    }, 520);
  }

  function startLiveWishlistIncrements(el, numberEl, baseCount) {
    var seed = wishlistSeed(el);
    var maxIncrements = 1 + (seed % 2);
    var incrementsDone = 0;
    var current = baseCount;

    function scheduleNext(delay) {
      el._wishlistTimer = setTimeout(tick, delay);
    }

    function tick() {
      if (incrementsDone >= maxIncrements) return;

      if (document.hidden) {
        scheduleNext(12000);
        return;
      }

      if (!isWishlistInView(el)) {
        scheduleNext(wishlistDelay(seed, incrementsDone + 4, 12000, 28000));
        return;
      }

      incrementsDone++;
      current++;
      numberEl.textContent = String(current);
      updateWishlistAriaLabel(el, current);
      flashWishlistTick(el);

      var nextDelay = wishlistDelay(seed, incrementsDone + 8, 35000, 90000);
      scheduleNext(nextDelay);
    }

    scheduleNext(wishlistDelay(seed, 3, 18000, 42000));
  }

  function scheduleOrganicCatchUp(el, numberEl) {
    var target = parseInt(el.dataset.wishlistCount, 10);
    var current = parseInt(el.dataset.wishlistStart, 10);
    if (isNaN(current)) {
      current = parseInt(numberEl.textContent, 10);
    }
    var seed = wishlistSeed(el);
    var step = 0;
    var entranceDelayMs = (parseFloat(el.style.getPropertyValue('--wishlist-delay')) || 0) * 1000;

    function finishCatchUp() {
      markWishlistSettled(el);
      startLiveWishlistIncrements(el, numberEl, current);
    }

    function tryTick() {
      if (current >= target) {
        finishCatchUp();
        return;
      }

      if (document.hidden) {
        el._scrollCountTimer = setTimeout(tryTick, 10000);
        return;
      }

      if (!isWishlistInView(el)) {
        el._scrollCountTimer = setTimeout(tryTick, wishlistDelay(seed, step + 20, 12000, 24000));
        return;
      }

      current++;
      numberEl.textContent = String(current);
      updateWishlistAriaLabel(el, current);
      flashWishlistTick(el);
      step++;

      if (current >= target) {
        el._scrollCountTimer = setTimeout(finishCatchUp, wishlistDelay(seed, step + 10, 3000, 8000));
        return;
      }

      el._scrollCountTimer = setTimeout(tryTick, wishlistDelay(seed, step, 8000, 22000));
    }

    el._scrollCountTimer = setTimeout(function () {
      markWishlistSettled(el);

      if (current >= target) {
        startLiveWishlistIncrements(el, numberEl, current);
        return;
      }

      el._scrollCountTimer = setTimeout(tryTick, wishlistDelay(seed, 1, 6000, 16000));
    }, entranceDelayMs + 900);
  }

  function initWishlistCounters(root) {
    var scope = root || document;
    var counters = scope.querySelectorAll('.ohp-card__wishlist-count:not([data-animated])');
    if (!counters.length) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function animateCounter(el) {
      if (el.dataset.animated) return;
      el.dataset.animated = 'true';
      el.classList.add('is-animated');

      var target = parseInt(el.dataset.wishlistCount, 10);
      var numberEl = el.querySelector('.ohp-card__wishlist-count-number');
      if (!numberEl || isNaN(target)) return;

      if (reduceMotion) {
        numberEl.textContent = String(target);
        updateWishlistAriaLabel(el, target);
        markWishlistSettled(el);
        return;
      }

      scheduleOrganicCatchUp(el, numberEl);
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            animateCounter(entry.target);
            observer.unobserve(entry.target);
          });
        },
        { threshold: 0.35, rootMargin: '0px 0px -4% 0px' }
      );

      counters.forEach(function (counter) {
        observer.observe(counter);
      });
      return;
    }

    counters.forEach(animateCounter);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initWishlistCounters();
  });

  document.addEventListener('shopify:section:load', function (event) {
    initWishlistCounters(event.target);
  });
})();
